import { accountsAccountsRouteProps } from 'src/navigation/routeProps'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createBackgroundReducer } from 'src/redux/genericReducers'

export interface AccountsAccountsState {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
}

export const initialState: AccountsAccountsState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
}

export type Actions = CreditCardsFullPaginatedDataActions

const CoreAccountsAccountsReducer = (
  state = initialState,
  action: Actions,
): AccountsAccountsState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
})

const AccountsAccountsReducer = createBackgroundReducer(
  accountsAccountsRouteProps,
  initialState,
  CoreAccountsAccountsReducer,
)

export default AccountsAccountsReducer
